/**
 * Utility for determining Australian school terms based on current date
 */
import { TERMS } from "../constants";
/**
 * Compute Australian school term for a given date.
 * Uses the TERMS constants for term start dates.
 */
export default function getTermForDate(date) {
    const year = date.getFullYear();
    // Check terms in reverse chronological order, excluding "Other"
    const termsWithDates = TERMS.filter((term) => term.startDate !== null);
    for (let i = termsWithDates.length - 1; i >= 0; i--) {
        const term = termsWithDates[i];
        if (date >= createTermDate(year, term.startDate)) {
            return term.value;
        }
    }
    // Fallback to term 1 (shouldn't happen given our data structure)
    return 1;
}
/**
 * Get the start date of the school term that contains the given date.
 * Term 1 starts on 1st January, so the containing term always starts
 * within the same calendar year as the given date.
 */
export function getTermStartDate(date) {
    const year = date.getFullYear();
    const termsWithDates = TERMS.filter((term) => term.startDate !== null);
    for (let i = termsWithDates.length - 1; i >= 0; i--) {
        const termStart = createTermDate(year, termsWithDates[i].startDate);
        if (date >= termStart) {
            return termStart;
        }
    }
    return new Date(year, 0, 1);
}
/**
 * Helper function to create a Date object from year and DD-MM format string (Australian format)
 */
function createTermDate(year, startDate) {
    const [day, month] = startDate.split("-").map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed in Date constructor
}
